import { Pagination } from 'api/interfaces';
import { get, post } from 'api/methods';

export interface IElementsAGN {
  codigoAgencia: string;
  numeroNucleo: string;
  percentualPresentes: number;
  quorumAtingido: boolean;
  totalConvocados: number;
  totalPresentes: number;
  totalPresentesAptos: number;
}

export type IQuorumByAGNResponse = Pagination<IElementsAGN[]>;

export interface IElementsAGO {
  id: string;
  cargo: number;
  codigoAgencia: string;
  flagModificacao: boolean;
  cpfCnpj: string;
  dataHora: string;
  nomeCargo: string;
  nomeConvocado: string;
  numeroNucleo: string;
  totalConvocados: number;
  totalPresentes: number;
}

export type IQuorumByAGOResponse = Pagination<IElementsAGO[]>;

interface QuorumResponse {
  existeQuorum: boolean;
}

export interface QuorumRequestAgn {
  agencias: string[];
  idEvento: number;
  nucleos: string[];
  page: number;
  quorumAtingido: number | null;
  size: number;
}

export interface QuorumRequestAgo {
  agencias: string[];
  idEvento: number;
  nucleos: string[];
  page: number;
  representado: number | null;
  size: number;
}

export interface QuorumDownloadAgn {
  agencias: string[];
  idEvento: number;
  nucleos: string[];
  quorumAtingido: any;
}

export interface QuorumSubstituirRepresentantes {
  agencia: string;
  idConvocado: number;
  idEvento: number;
  nucleo: string;
}

export interface IQuorumRepresentantes {
  idConvocado: number;
  nomeAssociado: string;
  nucleo: string;
  agencia: string;
  idCargo: number;
  nomeCargo: string;
  ativo: boolean;
  flagModificacao: boolean;
}

const quorum = {
  existe: (idEvento: number) => {
    return get<QuorumResponse>('assembleiasAssessor', 'quorum', {
      params: { idEvento },
    });
  },
  registrar: (idEvento: number) => {
    return post<boolean>('assembleiasAssessor', `quorum/${idEvento}`);
  },
  startVoting: (idEvento: number) => {
    return post<boolean>(
      'assembleiasAssessor',
      `evento/iniciar-votacao/${idEvento}`
    );
  },
  liberarPresencial: (oidEvento: number) => {
    return post<boolean>(
      'assembleiasAssessor',
      `pauta/liberar-resultado-presencial-evento?oidEvento=${oidEvento}`
    );
  },
  liberarPresencialPauta: (idEvento: number, oidPauta: number) => {
    return post<boolean>(
      'assembleiasAssessor',
      `pauta/liberar-resultado-presencial-pauta?idEvento=${idEvento}&oidPauta=${oidPauta}`
    );
  },
  listarByAGO: (payload: QuorumRequestAgo) => {
    return post<IQuorumByAGOResponse>(
      'assembleiasAssessor',
      'quorum/page',
      payload
    );
  },
  listarByAGN: (payload: QuorumRequestAgn) => {
    return post<IQuorumByAGNResponse>(
      'assembleiasAssessor',
      'quorum/page-agn',
      payload
    );
  },
  representantes: (agencia: string, idEvento: number, nucleo: string) => {
    return get<IQuorumRepresentantes>(
      'assembleiasAssessor',
      'quorum/representantes',
      {
        params: { agencia, idEvento, nucleo },
      }
    );
  },
  substituirRepresentantes: (payload: QuorumSubstituirRepresentantes) => {
    return post('assembleiasAssessor', 'quorum/substituir', payload);
  },
};

export default quorum;
